<template>
  <div style="display: flex; flex-wrap: wrap" :class="className">
    <span v-if="name" class="scence_ctr_span_title">{{ name }}</span>
    <div class="color-list-box">
      <div
        v-for="(item, index) in model.EnumValue"
        v-if="isSingle"
        :key="index"
        class="color-item"
      >
        <div
          :class="color === item.Value ? 'color-inner checked' : 'color-inner'"
          :style="{ background: reColor(item.Value, item) }"
          :title="item.Name"
          @click="confirmValue(item.Value)"
        />
        <div class="color-name" :title="item.Name">
          {{ item.Name }}
        </div>
      </div>
      <el-popover
        v-if="!isMode"
        v-model="showPanelColor"
        placement="top"
        popper-class="panel-box_new"
      >
        <div slot="reference" class="color-picker-box-new">
          <div :class="isSingle ? 'color-item' : ''">
            <div v-if="color === 0 || color === 1" class="border color-inner">
              +
            </div>
            <div
              v-else
              ref="colorsure"
              :class="[displayedColor ? 'color-inner' : 'border color-inner', isCustom ? 'checked' : '']"
              :style="{ background: displayedColor }"
              :title="$t('deviceMsg.colorCustomize')"
            >
              <img src="~@/assets/img/cunstom_edit.png" class="cunstom_edit">
            </div>
            <div v-if="isSingle" class="color-name" :title="$t('deviceMsg.colorCustomize')">
              {{ $t('deviceMsg.colorCustomize') }}
            </div>
          </div>
        </div>
        <div>
          <div class="panel-box-top">
            <div>{{ $t('deviceMsg.ciexy') }}:</div>
            <div style="display: flex">
              <div>
                cx：<el-input
                  :value="panelCX"
                  class="panel-input panel-input-cxcy"
                  @input="val => handleCxCyInput('panelCX', val)"
                  @keyup.native.enter="handleConfirm"
                  @blur="handleConfirm"
                />
                &nbsp;
              </div>
              <div>
                cy：<el-input
                  :value="panelCY"
                  class="panel-input panel-input-cxcy"
                  @input="val => handleCxCyInput('panelCY', val)"
                  @keyup.native.enter="handleConfirm"
                  @blur="handleConfirm"
                />
              </div>
            </div>
          </div>
          <panel
            v-if="showPanelColor"
            ref="colorPanl"
            :color="color"
            :config="{ config: config, matrix: matrix }"
            :image="model?.UI?.Icon"
            @confirmValue="confirmValue"
            @handlePanelColor="handlePanelColor"
          />
        </div>
      </el-popover>
    </div>
  </div>
</template>

<script>
import panel from './components/panel.vue'
// import Clickoutside from 'element-ui/src/utils/clickoutside'
import { CxCyValueToRGBHex } from '@/utils/colors.js'

export default {
  components: {
    panel,
  },
  // directives: { Clickoutside },
  props: {
    className: {
      type: String,
      default: '',
    },
    isVisible: {
      type: Boolean,
      default: false,
    },
    config: {
      type: Object,
      required: true,
    },
    matrix: {
      type: Number,
      required: true,
    },
    color: {
      type: Number || String,
      required: true,
    },
    model: {
      type: Object,
      Default: {},
      required: true,
    },
    isSingle: {
      type: Boolean,
      default: true,
    },
    //日光模式 天际模式
    isMode: {
      type: Boolean,
      default: false,
    },
    name: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      showPanelColor: false,
      panelColor: '',
      panelCX: 0,
      panelCY: 0,
    }
  },
  computed: {
    displayedColor() {
      if (this.showPanelColor) {
        return this.panelColor || CxCyValueToRGBHex(this.color)
      } else {
        try {
          return CxCyValueToRGBHex(this.color)
        } catch (error) {
          return 0
        }
      }
    },
    isCustom() {
      if (!this.model || !this.model.EnumValue) {
        return false
      }
      let hasColor = this.model.EnumValue.filter(item => {
        return this.color === item.Value
      })
      if (this.model.EnumValue.length > 0 && hasColor.length > 0) {
        return false
      } else {
        return true
      }
    },
  },
  methods: {
    reColor(color, item) {
      try {
        if (this.isMode) {
          return `url(${item.IconUrl?.n}) no-repeat center center`
        }
        return CxCyValueToRGBHex(color)
      } catch (error) {}
      return 0
    },
    handleShowColorPicker() {
      this.showPanelColor = !this.showPanelColor
    },
    confirmValue(e) {
      this.$emit('change', e)
    },
    handlePanelColor(e) {
      this.panelColor = null
      this.panelCX = e.cx.toFixed(4)
      this.panelCY = e.cy.toFixed(4)
      this.$emit('rgb-change', e)
    },
    hide() {
      this.showPanelColor = false
    },
    hasValidCxCyPrecision(str) {
      const decimalPart = String(str ?? '').trim().split('.')[1]
      return !decimalPart || decimalPart.length <= 4
    },
    handleCxCyInput(field, value) {
      let str = String(value ?? '').replace(/[^\d.]/g, '')
      const dotIndex = str.indexOf('.')
      if (dotIndex !== -1) {
        str = str.slice(0, dotIndex + 1) + str.slice(dotIndex + 1).replace(/\./g, '')
      }
      const parts = str.split('.')
      if (parts[1] && parts[1].length > 4) {
        this.$message.warning(this.$t('deviceMsg.cxCyEmpty'))
        str = `${parts[0]}.${parts[1].slice(0, 4)}`
      }
      this[field] = str
    },
    handleConfirm() {
      const cxStr = String(this.panelCX ?? '').trim()
      const cyStr = String(this.panelCY ?? '').trim()

      if (!cxStr || !cyStr) {
        this.$message.warning(this.$t('deviceMsg.cxCyEmpty'))
        return
      }

      if (!/^\d+(\.\d+)?$/.test(cxStr) || !/^\d+(\.\d+)?$/.test(cyStr)) {
        this.$message.warning(this.$t('deviceMsg.cxCyFormatError'))
        return
      }

      if (!this.hasValidCxCyPrecision(cxStr) || !this.hasValidCxCyPrecision(cyStr)) {
        this.$message.warning(this.$t('deviceMsg.cxCyEmpty'))
        return
      }

      const cx = Number(cxStr)
      const cy = Number(cyStr)
      if (Number.isNaN(cx) || Number.isNaN(cy)) {
        this.$message.warning(this.$t('deviceMsg.cxCyFormatError'))
        return
      }

      if (!(cx >= 0 && cx <= 1 && cy >= 0 && cy <= 1)) {
        this.$message.warning(this.$t('deviceMsg.cxCyOutOfRange'))
        return
      }

      const a = parseInt(cx * 10000, 10) & 0xffff
      const b = parseInt(cy * 10000, 10) & 0xffff
      this.confirmValue((a << 16) | b)
    },
  },
}
</script>

<style lang="scss" scoped>
.color-picker-box-new {
  z-index: 1002;
  position: relative;
}

.color-list-box {
  flex: 1;
  .color-inner {
    position: relative;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    z-index: 999;
    cursor: pointer;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #d8d8d8;
    background-size: contain !important;

    span {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: rotate(-50%, -50%);
    }
  }

  .checked {
    padding: 0;
    border: 3px solid #2589ff;
  }

  .border {
    border: 1px dashed #d8d8d8;
  }

  .color-item {
    margin-right: 10px;
    display: flex;
    align-items: center;
    flex-direction: column;
    margin-bottom: 10px;
  }

  .color-name {
    margin-top: 5px;
    // line-height: 20px;
    text-align: center;
    width: 80px;
    font-size: 12px;
    display: block;
    // height: 40px;
    // overflow: hidden;
  }
}

.color-list-box {
  display: flex;
  flex-wrap: wrap;
  //margin-left: -20px;
}
.cunstom_edit {
  position: absolute;
  top: 0px;
  right: -3px;
  width: 23px;
  height: 23px;
}
</style>
<style>
.panel-box-top .el-input__inner {
  padding: 0 0;
  height: 20px !important;
  text-align: center;
}

.panel-box_new {
  background: #fff;
  padding: 5px;
  box-shadow: 0px 4px 15px 0px rgba(0, 0, 0, 0.302);
  border-radius: 5px;
}
.panel-box_new .panel-box-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 12px;
  height: 25px;
}
.panel-box_new .panel-input {
  width: 50px;
  height: 20px;
}
.panel-box_new .panel-input-cxcy {
  width: 68px;
}

.panel-box_new .color-panel::before {
  display: none;
}
</style>
